// extracted by mini-css-extract-plugin
module.exports = {"light":"themes_light__B1aTE","dark":"themes_dark__vp2Z5","purple":"themes_purple__kskqq"};